"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageData = exports.ImageType = void 0;
const element_vir_1 = require("@augment-vir/element-vir");
const element_vir_2 = require("element-vir");
var ImageType;
(function (ImageType) {
    ImageType["Html"] = "html";
    ImageType["Svg"] = "svg";
    ImageType["Image"] = "image";
    ImageType["Video"] = "video";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
async function determineImageType(imageResponse, imageText) {
    var _a;
    const contentType = (_a = imageResponse.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : '';
    if (contentType.includes('video')) {
        return ImageType.Video;
    }
    else if (contentType.includes('svg') || imageText.includes('<svg')) {
        return ImageType.Svg;
    }
    else if (contentType.includes('html') || imageText.includes('<html')) {
        return ImageType.Html;
    }
    else {
        return ImageType.Image;
    }
}
function generateTemplateString({ imageType, imageText, imageUrl, blockAutoPlay, }) {
    if (imageType === ImageType.Image) {
        return (0, element_vir_1.convertTemplateToString)((0, element_vir_2.html) `
            <img src=${imageUrl} />
        `);
    }
    else if (imageType === ImageType.Video) {
        return (0, element_vir_1.convertTemplateToString)((0, element_vir_2.html) `
            <video
                ${blockAutoPlay ? '' : 'autoplay'}
                muted
                loop
                onclick="this.paused ? this.play() : this.pause()"
            >
                <source src=${imageUrl} type="video/mp4" />
            </video>
        `);
    }
    else {
        return imageText;
    }
}
async function getImageData(imageUrl, blockAutoPlay) {
    var _a;
    let imageResponse;
    try {
        imageResponse = await fetch(imageUrl);
    }
    catch (error) { }
    const imageText = (_a = (await (imageResponse === null || imageResponse === void 0 ? void 0 : imageResponse.text()))) !== null && _a !== void 0 ? _a : '';
    const imageType = imageResponse
        ? await determineImageType(imageResponse, imageText)
        : // naively assume it's an image
            ImageType.Image;
    const templateString = generateTemplateString({
        imageText,
        imageType,
        imageUrl,
        blockAutoPlay,
    });
    return {
        templateString,
        imageUrl,
        imageType,
    };
}
exports.getImageData = getImageData;
